/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import _, { isNil } from 'lodash';
import { toast } from 'react-toastify';
import { get, isEmpty } from 'lodash';
import currentUserStorage from 'containers/services/security/current-user-storage';
import {
  Container,
  SahamTabsGlobal,
  StyledTopDiv,
} from 'containers/CourtManagerLegalProceedings/styled-components';
import ClaimRecap from 'containers/LawyerRecapPage/LawyerRecap';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import GlobalLegalProceedingTabs from 'components/GlobalLegalProceedingTabs';
import {
  makeSelectCurrentInstanceTab,
  makeSelectCurrentTabManager,
  makeSelectLinkToBeneficiaryCodes,
  makeSelectListings,
  makeSelectGlobalCurrentTabManager,
  makeSelectCurrentTabJudiciaryProcessManager,
  makeSelectNotificationsInboxes,
  makeSelectCurrentTabIndexExpertise,
  makeSelectCurrentTabIndexTransaction,
  makeSelectTransactionId,
} from 'containers/AppContainer/selectors';
import { formatVictimsToDahirAmount } from 'containers/LawyerLegalProceedingsPage/utils';
import { makeSelecClaimRecap } from 'containers/RecapManagerPage/selectors';
import {
  requestAssigment,
  requestClaimRecap,
  requestUpdateVictimInfo,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestValidateProvisionIntervenant,
  resetStoreClaim,
} from 'containers/RecapManagerPage/actions';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import {
  makeSelectExpertiseRaport,
  makeSelectJudgementAdd,
  makeSelectJudgementOnMerits,
  makeSelectJudgementAppeal,
  makeSelectDahirAmounts,
  makeSelectDahirAmountsCorpo,
  makeSelectJudgementOnMeritsAppeal,
  makeSelectExpertiseRaportAppeal,
  makeSelectJudgementAddAppeal,
  makeSelectJudgementOnMeritsMultiple,
  makeSelectAppealOnMeritsMultiple,
} from 'containers/LawyerLegalProceedingsPage/selectors';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import {
  requestGetDecisionFlowVictims,
  requestGetExpertUsers,
} from 'containers/CourtManagerLegalProceedings/actions';
import {
  requestGetJudgementAdd,
  requestGetDahirAmount,
  requestCreateJudgementOnMeritsContestation,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  requestGetJudgementAddAppeal,
  updateContestation,
  requestUploadContestationDocument,
  requestGetJudgementOnMeritsMultiple,
  requestGetAppealOnMeritsMultiple,
  setLockedClaim,
  resetLegalProceeding,
} from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestMakeJudgementAddDecision,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestValidateJudgementAppeal,
  requestCreateCivilProceeding,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestMakeJudgementAddDocumentDecision,
  requestAddVictims,
  requestAddVehicles,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestIsSuspiciosClaim,
  requestCreateJudgementAdd,
  requestLockClaim,
  requestUnlockClaim,
  requestMakeDecisionsDocumentImaging,
  requestGetClaimHistoryActions,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestCreateStakeHolder,
  requestSetPriorityClaimProvision,
  requestGetInstructions,
  requestCreateInstruction,
  requestResetHistoryStore,
  requestCreateIncomeCertificate,
  requestUpdateIncomeCertificate,
  requestUploadDocumentManager,
} from 'containers/CourtManagerLegalProceedings/actions';
import {
  IAppealPayload,
  ICurrentSteps,
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { getLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/actions';
import { makeSelectLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/selectors';
import {
  requestGetExpertiseRaport,
  requestGetJudgementOnMerits,
  requestGetJudgementAppeal,
  requestCreateMultipleJudgementAdd,
  requestGetDahirAmountCorpo,
  requestCreateExpertiseRaport,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
} from 'containers/LawyerLegalProceedingsPage/actions';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestGetReportsPolicy,
} from 'containers/UploadDocuments/actions';
import {
  requestCreateFeeNote,
  requestUpdateFeeNoteStatus,
  requestUpdateFirmReferenceManager,
  requestUpdateInvoiceFeeNote,
} from 'containers/LawyerFeeNote/actions';
import {
  requestAddEligibilityTransaction,
  requestUpdateEligibilityTransaction,
  requestAddTransaction,
  requestGetTransaction,
  requestUpdateTransaction,
  requestAddContactTransaction,
  requestGetContactTransaction,
  resetStoreTransaction,
  requestUpdateContactTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestUpdateMissionTransaction,
  requestGetFeeNotesTransaction,
  requestImportMissionExpertise,
  requestGetJudiciaryExpertReport,
  requestMakeDecisionVictimInfo,
  requestRejectTransaction,
  requestAddQuotationDocument,
  requestGetTransactionInboxeArea,
} from 'containers/TransactionManagerTimeLine/actions';
import {
  requestCreateFeeNoteManager,
  requestManagerFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import { requestFeeNoteExceptionalCosts } from 'containers/ManagerFeeNote/actions';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import { makeSelectCivilProceeding } from 'containers/LawyerLegalProceedingsPage/selectors';
import { requestCreateJudgementOnMerits } from 'containers/LawyerLegalProceedingsPage/actions';
import { PAGES } from 'routes';
import routesHelper from 'containers/services/routes-helper';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import {
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import { makeDecisionFeeNote } from 'containers/ManagerFeeNote/actions';
import { requestGetCivilProceeding } from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestGetNotificationsInboxes,
  setCurrentInstanceTab,
  setCurrentIndexTabTransaction,
} from 'containers/AppContainer/actions';
import { CLAIM_STATUS } from 'containers/data-structure';
import { makeSelectCorporealExperts } from 'containers/RecapManagerPage/selectors';
import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import ManagerLegalProceedingsPage from 'containers/ConsultationLegalProceedingPage/legalProceedings';
import DialogDisclaimerWarranty from 'components/DialogDisclaimerWarranty';
import { requestAddInvoiceFeeNote } from 'containers/LawyerFeeNote/actions';
import {
  requestSagisClaimInfo,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestCreateCorpoEncryptedDocument,
  requestCreateCorporealRegulation,
  requestCreateMaterialRegulation,
  requestCreateAdditionalWarrentiesRegulation,
  requestMaterialEncryptedDocument,
  requestGetAssignedLawyers,
  requestGetRegulations,
  resetSagisInfoClaim,
  requestCreateSummarySheetRegulation,
  uploadDocumentRegulation,
  requestValidateProvision,
  requestGetRegulation,
  requestValidateRegulation,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  makeSelectSagisClaim,
  makeSelectJudgementOnMeritsByVictims,
  makeSelectJudgementOnMeritsByVehicles,
  makeSelectEncryptedDocuments,
  makeSelectMaterialEncryptedDocuments,
  makeSelectAssignedLawyers,
  makeRegulations,
  makeCreatedRegulations,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';

import {
  PROVISION_TAB_LABELS,
  REGULATION_TAB_LABELS_CONSULTATION,
} from 'containers/CourtManagerLegalProceedings/constants';
import {
  claimTabs,
  isLockedClaim,
  isBlockStatusClaim,
  filterFeeNotes,
  getClaimInfoSagis,
  getLabelsWithLabelsIds,
  renderTabsTitle,
  getVictimNamesWithJudgement,
  getVictimNamesWithTransaction,
} from 'containers/CourtManagerLegalProceedings/utils';
import { TopCard } from 'containers/CourtManagerLegalProceedings/TopCard';
import JudiciaryProcessTabs from 'components/JudiciaryProcessTabs';
import { LISTINGS } from 'containers/data-structure';
import useDeepCompareEffect from 'use-deep-compare-effect';
import * as util from 'containers/RecapManagerPage/utils';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import ProvisionContainer from 'containers/CourtManagerLegalProceedings/Provision';
import ExpertiseExpert from 'containers/CourtManagerLegalProceedings/ExpertiseExpert';
import { requestGetExpertiseVictim } from 'containers/ExpertExpertise/actions';
import {
  resolveSagisClaim,
  shouldShowVictimExcludedWarning,
} from 'helpers/utils';
import { requestUpdateFeeNoteAmount } from 'containers/LawyerFeeNote/actions';
import RegulationRecapContainer from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationRecapContainer';
import { makeSelectVictimExpertise } from 'containers/ExpertExpertise/selectors';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import SuspiciosClaimDialog from 'containers/CourtManagerLegalProceedings/SuspiciosClaimDialog';
import SuspiciousCard from 'containers/CourtManagerLegalProceedings/SuspiciousCard';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { requestUpdateClaim } from 'containers/PreOpeningPage/actions';
import ImagineDocumentsDrawer from 'containers/CourtManagerLegalProceedings/ImagineDocuments';
import useCollapse from 'hooks/useCollapse';
import {
  makeSelectClaimHistoryActions,
  makeSelectDecisionJudgmentIds,
  makeSelectClaimHistorySagis,
  makeInstructions,
  makeSelectDecisionFlowVictim,
} from 'containers/CourtManagerLegalProceedings/selectors';
import TrackingActionDrawer from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer';
import { priorityClaimReason } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import Transaction from 'containers/TransactionManagerTimeLine/Transaction';
import WarningCard from 'containers/common/Card/WarningCard';
import { makeSelectTransactionInboxeAreaId } from 'containers/TransactionManagerTimeLine/selector';
import { requestGetJudgements } from 'containers/common/LegalProceedings/actions';
import { GLOBAL_STATUS, OPENING_STATE } from 'services/constants';
import DialogFeeNote from 'components/DialogFeeNote';
import { ClaimRecapType } from 'typings/claimTypes';

export interface TransactionManagerTimeLinePageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  requestClaimRecap: Function;
  getLegalProceedingsSteps: Function;
  claimRecap: ClaimRecapType;
  currentSteps: ICurrentSteps[];
  policyInfo: { sagis: { claims: any } };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number } };
  requestGetJudgementAdd: Function;
  judgementAdd: IJudgementAdd;
  requestMakeJudgementAddDecision: Function;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  requestValidateExpertReport: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestValidateJudgementOnMerits: Function;
  requestValidateDisclaimerWarranty: Function;
  requestGetJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  documentId: string;
  setDocumentId: Function;
  judgementAppeal: IAppealPayload;
  requestGetJudgementAppeal: Function;
  requestValidateJudgementAppeal: Function;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  feeNotes: FeeNote[];
  feeNotesCount: number;
  resetUploadDocumentStore: Function;
  requestManagerFeeNotes: Function;
  requestFeeNotesByClaimNumb: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  keyclokToken: string | null;
  makeDecisionFeeNote: Function;
  currentTabInstance: string;
  setCurrentInstanceTab: Function;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  requestCreateCivilProceeding: Function;
  requestGetCivilProceeding: Function;
  judiciaryProcessId: number;
  civilProceeding: [];
  requestCreateJudgementOnMerits: Function;
  requestAssignedExpert: Function;
  requestUpdatedCivilProceeding: Function;
  selectedClaim: any;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  dahirAmountsCorpo: any;
  requestGetDahirAmountCorpo: Function;
  requestCreateJudgementOnMeritsContestation: any;
  requestGetJudgementOnMeritsAppeal: any;
  judgementOnMeritsAppeal: any;
  expertiseRaportAppeal: any;
  requestGetExpertiseReportAppeal: any;
  requestGetJudgementAddAppeal: Function;
  requestValidatedCivilProceeding: Function;
  judgementAddAppeal: any;
  requestMakeJudgementAddDocumentDecision: Function;
  requestAssigment: Function;
  requestAddVictims: Function;
  linkToBeneficiaryCodes: SagisConfig[];
  updateContestation: Function;
  requestUploadContestationDocument: Function;
  requestUpdateVictimInfo: Function;
  requestUpdateBeneficiaryInfo: Function;
  requestUpdateVehicleInfo: Function;
  setClaimRecap: Function;
  requestAddVehicles: Function;
  requestGetJudgementOnMeritsMultiple: Function;
  requestGetAppealOnMeritsMultiple: Function;
  judgementOnMeritsMultiple: any;
  appealOnMeritsMultiple: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  judgementOnMeritsByVehicles: any;
  requestGetExpertiseVictim: Function;
  requestMakeDecisionMissionExpertise: Function;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  requestCreateCorpoEncryptedDocument: Function;
  requestCreateCorporealRegulation: Function;
  requestCreateMaterialRegulation: Function;
  requestCreateAdditionalWarrentiesRegulation: Function;
  corporealEncryptedDocuments: any;
  requestUpdateFeeNoteAmount: Function;
  expertExpertise: any;
  materialEncryptedDocuments: any;
  requestMaterialEncryptedDocument: Function;
  loaders: any;
  requestIsSuspiciosClaim: Function;
  requestCreateJudgementAdd: Function;
  requestGetAssignedLawyers: Function;
  requestGetExpertUsers: Function;
  assignedLawyers: AssignedLawyer[];
  requestCreateMultipleJudgementAdd: Function;
  requestCreateExpertiseRaport: Function;
  requestUpdateClaim?: Function;
  currentIndexTabManager: any;
  currentGlobalTabManagerIndex: any;
  currentInstanceTabIndexManager: any;
  currentJudiciaryProccessId: any;
  requestAddSupportDocument: Function;
  requestCivilPartySupportDocument: Function;
  requestAddExpertiseSupportDocument: Function;
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestValidateProvisionIntervenant: Function;
  requestLockClaim: Function;
  requestUnlockClaim: Function;
  setLockedClaim: any;
  requestGetRegulations: Function;
  regulations: any;
  managerNotifcationsInboxes: any;
  resetStoreClaim: Function;
  resetSagisInfoClaim: Function;
  resetLegalProceeding: Function;
  createdRegulations: any;
  requestCreateSummarySheetRegulation: Function;
  uploadDocumentRegulation: Function;
  requestMakeDecisionsDocumentImaging: Function;
  requestGetNotificationsInboxes: Function;
  requestValidateProvision: Function;
  currentTabManagerExpertise: any;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  decisionJudgementIds: any;
  requestGetClaimHistoryActions: Function;
  userActions: any;
  requestUpdateFeeNoteStatus: Function;
  setDecisionsJudgementIds: Function;
  requestGetClaimHistorySagis: Function;
  claimHistorySagis: any;
  requestSetStatusClaimSagis: Function;
  requestCreateStakeHolder: Function;
  requestSetPriorityClaimProvision: Function;
  requestGetInstructions: Function;
  requestCreateInstruction: Function;
  instructions: any;
  requestResetHistoryStore: Function;
  requestCreateFeeNoteManager: Function;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  requestAddEligibilityTransaction: Function;
  requestAddTransaction: Function;
  requestGetTransaction: Function;
  requestUpdateTransaction: Function;
  requestUpdateEligibilityTransaction: Function;
  requestAddContactTransaction: Function;
  requestGetContactTransaction: Function;
  requestUpdateContactTransaction: Function;
  resetStoreTransaction: Function;
  requestGetMissionTransaction: Function;
  requestGetMissionVictimExpertise: Function;
  requestUpdateMissionTransaction: Function;
  requestGetFeeNotesTransaction: Function;
  requestGetReportsPolicy: Function;
  requestImportMissionExpertise: Function;
  requestGetJudiciaryExpertReport: Function;
  requestMakeDecisionVictimInfo: Function;
  currentVerticalTabs: any;
  storedTransactionId: number;
  requestRejectTransaction: Function;
  setCurrentIndexTabTransaction: Function;
  requestGetRegulation: Function;
  requestValidateRegulation: Function;
  corpoRegulation: any;
  requestAddQuotationDocument: Function;
  requestUploadDocumentManager: Function;
  requestGetTransactionInboxeArea: Function;
  transactionInboxeAreaId: any;
  requestGetDocByDocumentumId: Function;
  requestGetJudgements: Function;
  requestUpdateFirmReferenceManager: Function;
  requestGetDecisionFlowVictims: Function;
  victimDecisionFlow: any;
}

export const TransactionManagerTimeLinePage: React.FC<TransactionManagerTimeLinePageProps> = (
  props,
): JSX.Element => {
  const [isButtonRedirect, setIsButtonRedirect] = useState(false);
  const [openTrackingDrawer, setOpenTrackingDrawer] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      return () => {
        props.requestUnlockClaim(
          {
            claimNumber: get(props.claimRecap, 'claim.claimNumber'),
          },
          () => {
            props.setLockedClaim(null);
            props.resetSearchClaimsStore();
            props.resetStoreClaim();
            props.requestResetHistoryStore();
          },
        );
      };
    } else {
      return () => {
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.requestResetHistoryStore();
      };
    }
  }, []);
  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      const handleBeforeUnload = (event: any) => {
        const message = 'vous allez quitter le mode de gestion du sins';
        event.returnValue = message;
        props.requestUnlockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
      };

      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
      };
    } else {
      return () => {
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
      };
    }
  }, []);
  useDeepCompareEffect(() => {
    if (!isEmpty(get(props.policyInfo, 'sagis', {}))) {
      if (
        !isLockedClaim(props.policyInfo) &&
        featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM) &&
        !isNil(get(props.claimRecap, 'claim.claimNumber', null)) &&
        !isBlockStatusClaim(props.policyInfo) &&
        get(props, 'claimRecap.claim.status') === GLOBAL_STATUS.VALIDATED
      ) {
        props.requestLockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
        props.setLockedClaim(get(props.claimRecap, 'claim.claimNumber'));
      }
    }
  }, [props.claimRecap, props.policyInfo]);
  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', [])) &&
      featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
      (isNil(get(props.claimRecap, 'claim.priorityReasonId', null)) ||
        get(props.claimRecap, 'claim.priorityReasonId', null) != 4)
    ) {
      const priorityReason = priorityClaimReason(
        [],
        !isEmpty(get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []))
          ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
              .map((el: any) => Number(el.riskProvisions))
              .reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + currentValue,
              )
          : 0,
        props.listings,
      );
      if (priorityReason) {
        props.requestSetPriorityClaimProvision({
          id: Number(claimId),
          claimInfo: { priorityReasonId: priorityReason },
          username: currentUserStorage.get().username,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        });
      }
    }
  }, [props.policyInfo]);
  useEffect(() => {
    if (
      !isEmpty(props.claimRecap) &&
      get(props, 'claimRecap.claim.status') !== GLOBAL_STATUS.VALIDATED
    ) {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.resetSagisInfoClaim();
      props.resetLegalProceeding();
      props.requestResetHistoryStore();
    }
  }, [
    props.claimRecap,
    props.listings,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentTabInstance,
  ]);
  const [OpenDrawerImagineDocuments, setOpenDraweImagineDocuments] = useState(
    false,
  );

  useEffect(() => {
    props.requestGetDahirAmount(
      get(
        formatVictimsToDahirAmount(get(props.claimRecap, 'victims', [])),
        'injured',
        [],
      ),
      get(
        formatVictimsToDahirAmount(get(props.claimRecap, 'victims', [])),
        'deceased',
        [],
      ),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap]);
  const [expandRow, setExpandRow] = useCollapse(
    get(props.listings, 'managerInboxes', []),
  );
  const handleToggleDrawer = () => {
    setOpenDraweImagineDocuments(!isDrawerOpen);
  };
  const handleToggleTrackingDrawer = () => {
    setOpenTrackingDrawer(!openTrackingDrawer);
  };
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [isSuspiciosClaimDialog, setIsSuspiciosClaimDialog] = React.useState(
    false,
  );

  const claimId = props.match.params.claimId;
  const claimNumber = get(props.claimRecap, 'claim.claimNumber', null);
  const corporealExperts = useSelector(makeSelectCorporealExperts());

  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);

  const [currentRegulationTab, setCurrentRegulationTab] = useState(0);

  const [idCivilProceeding, setIdCivilProceeding] = React.useState<number>(0);
  const [isWarrantyDialogOpen, setIsWarrantyDialogOpen] = useState<boolean>(
    false,
  );
  const [currentJudiciaryProcess, setCurrentJudiciaryProcess] = React.useState<
    any
  >({});
  const [
    isAssignmentClaimDrawerOpen,
    setIsAssignmentClaimDrawerOpen,
  ] = useState<boolean>(false);
  const [isAddVictimCardOpen, setIsAddVictimCardOpen] = useState<boolean>(
    false,
  );
  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    props.requestGetCivilProceeding(claimId);
    if (
      featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) &&
      !isNil(get(props.claimRecap, 'claim.claimNumber', null))
    ) {
      props.requestGetClaimHistoryActions(claimId);
    }
  }, [
    claimId,
    props.claimRecap,
    props.currentIndexTabManager,
    props.currentGlobalTabManagerIndex,
  ]);
  useEffect(() => {
    props.requestGetTransactionInboxeArea(claimId);
    props.requestGetDecisionFlowVictims(claimId);
  }, [claimId]);

  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    if (
      featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) &&
      !isNil(claimNumber)
    ) {
      props.requestGetClaimHistoryActions(claimId);
      props.requestGetClaimHistorySagis(claimNumber);
    }
    if (props.currentJudiciaryProccessId) {
      props.requestGetCivilProceeding(claimId);
      props.requestClaimRecap(claimId);
      setIdCivilProceeding(props.currentJudiciaryProccessId);
      if (get(props.civilProceeding, '[0].id')) {
        props.getLegalProceedingsSteps(
          claimId,
          props.currentJudiciaryProccessId,
        );
        props.requestClaimRecap(claimId);
      }
    } else {
      const correctionnelProceeding = get(props, 'civilProceeding', []).filter(
        (element: { procedureNatureId: number }) =>
          element.procedureNatureId === 3,
      );
      props.requestGetCivilProceeding(claimId);
      props.requestClaimRecap(claimId);
      setIdCivilProceeding(get(correctionnelProceeding, '[0].id'));
      if (
        featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) &&
        !isNil(get(props.claimRecap, 'claim.claimNumber', null))
      ) {
        props.requestGetClaimHistoryActions(claimId);
      }
      if (get(props.civilProceeding, '[0].id')) {
        props.getLegalProceedingsSteps(
          claimId,
          get(props.civilProceeding, '[0].id'),
        );
        props.requestClaimRecap(claimId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    claimId,
    claimNumber,
    props.currentIndexTabManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
  ]);

  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', {})) &&
      !isEmpty(props.claimRecap)
    ) {
      if (isLockedClaim(props.policyInfo)) {
        toast.error(
          translate({ ...messages.errorLockedClaim }, props, {
            username: get(
              resolveSagisClaim(props.policyInfo),
              'lockedBy',
              null,
            ),
          }) as string,
        );
        props.resetStoreClaim();
        props.resetSearchClaimsStore();
        props.requestResetHistoryStore();
        routesHelper.pushTo(
          `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
            'match',
            'params',
            'claimId',
          ])}`,
        )();
      } else if (
        isBlockStatusClaim(props.policyInfo) ||
        get(props.claimRecap, 'claim.status') != CLAIM_STATUS.VALIDATED ||
        get(props.claimRecap, 'claim.openingState') != OPENING_STATE.COMPLETED
      ) {
        props.resetStoreClaim();
        props.resetSearchClaimsStore();
        routesHelper.pushTo(
          `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
            'match',
            'params',
            'claimId',
          ])}`,
        )();
      }
    }
  }, [
    props.policyInfo,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
    props.claimRecap,
  ]);
  React.useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = util.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.listings,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
  ]);
  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!_.isEmpty(props.corporealLawyers)]);
  useEffect(() => {
    if (claimId && !isNil(get(props.claimRecap, 'claim.claimNumber', null))) {
      props.requestGetExpertiseVictim({
        missionId: null,
        claimId,
        missionVictimId: null,
        missionVehicleId: null,
        isIntervenant: false,
        isLegalProceeding: true,
      });
    }
  }, [!claimId, props.claimRecap, idCivilProceeding]);

  const handleOpen = () => {
    setIsDialogOpen(true);
    props.setDecisionsJudgementIds({});
  };
  const handleOpenAssignment = () => {
    setIsAssignmentClaimDrawerOpen(true);
  };

  const handleOpenDisclaimerWarrantyReasons = () =>
    setIsWarrantyDialogOpen(true);
  const handleOpenExpertiseFeeNote = () => {};
  const toggleDrawerAssignmentClaim = () => {
    setIsAssignmentClaimDrawerOpen(!isAssignmentClaimDrawerOpen);
  };

  const toggleAddVictimCard = () => {
    setIsAddVictimCardOpen(!isAddVictimCardOpen);
  };

  const handleCloseWarrantyDialog = () => setIsWarrantyDialogOpen(false);

  const successCallBackValidationWarrantyReason = () => {
    toast.success(translate(messages.successDialogWarrantyReason, props));
    setIsWarrantyDialogOpen(false);
  };

  const handleValidateWarrantyDialog = (reasonId: number) => () => {
    props.requestValidateDisclaimerWarranty(
      { id: claimId, reasonId },
      successCallBackValidationWarrantyReason,
    );
  };
  const handleResetStore = () => {
    props.requestUnlockClaim(
      {
        claimNumber: get(props.claimRecap, 'claim.claimNumber'),
      },
      () => {
        props.setLockedClaim(null);
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.requestResetHistoryStore();
      },
    );
  };
  const riskKey = getClaimInfoSagis(props.policyInfo)?.riskKey;
  const { labes, labesWithIds } = getLabelsWithLabelsIds(props.civilProceeding);

  const handleClickVerticalTabs = (tabIndex: number) => {
    const idCivilProceeding = labesWithIds[tabIndex]?.id;
    props.civilProceeding.forEach(
      (el: { procedureNatureId: number; id: number; courtNumber: string }) => {
        if (el.id === idCivilProceeding) {
          setIdCivilProceeding(el.id);
          setCurrentJudiciaryProcess(el);
        }
      },
    );
  };

  useEffect(() => {
    if (currentRegulationTab === 0 && !isNil(claimNumber)) {
      !isNil(claimNumber) && props.requestSagisClaimInfo(claimNumber);
      claimId && props.requestGetRegulations(claimId);
    }
  }, [currentRegulationTab, props.claimRecap]);
  const { currentTabIndex, labels = [] } = {
    currentTabIndex:
      props.currentGlobalTabManagerIndex ||
      claimTabs(renderTabsTitle(props))?.currentTabIndex,
    labels: claimTabs(renderTabsTitle(props))?.labels,
  };
  const handleOpenFeeNoteDialog = (payload: any) => {};
  const handleClose = () => {
    setIsDialogOpen(false);
    props.setDecisionsJudgementIds({});
  };
  return (
    <Container>
      <StyledTopDiv>
        {get(props.claimRecap['claim'], ['suspicious']) &&
          featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
            <SuspiciousCard />
          )}
        {shouldShowVictimExcludedWarning(
          get(props.claimRecap, 'victims'),
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE),
        ) && (
          <WarningCard
            message={messages.victimExcludedFromCoverageWarningMessage}
          />
        )}
        {featureService.hasFeature(FEATURES.TRANSACTION) &&
          !isEmpty(props.victimDecisionFlow) && (
            <>
              {!isEmpty(
                getVictimNamesWithJudgement(
                  props.victimDecisionFlow,
                  get(props.claimRecap, ['victims'], []),
                ),
              ) && (
                <WarningCard
                  message={messages.warningJudiciaryTitle}
                  isWarning={true}
                  textParams={getVictimNamesWithJudgement(
                    props.victimDecisionFlow,
                    get(props.claimRecap, ['victims'], []),
                  )}
                />
              )}
              {!isEmpty(
                getVictimNamesWithTransaction(
                  props.victimDecisionFlow,
                  get(props.claimRecap, ['victims'], []),
                ),
              ) && (
                <WarningCard
                  message={messages.warningTransactionTitle}
                  isWarning={true}
                  textParams={getVictimNamesWithTransaction(
                    props.victimDecisionFlow,
                    get(props.claimRecap, ['victims'], []),
                  )}
                />
              )}
            </>
          )}
        <TopCard
          claimNumber={get(props.claimRecap['claim'], 'claimNumber', '')}
          claimRecap={props.claimRecap}
          sagisClaim={props.sagisClaim}
          inputProps={{ disableUnderline: true }}
          intl={props.intl}
          setDropDown={setDropDown}
          dropDown={dropDown}
          toggleDrawer={toggleDrawer}
          handleOpenCivilProceeding={() => {}}
          handleOpenDisclaimerWarrantyReasons={
            handleOpenDisclaimerWarrantyReasons
          }
          requestSagisClaimInfo={props.requestSagisClaimInfo}
          toggleDrawerAssignmentClaim={toggleDrawerAssignmentClaim}
          toggleAddVictimCard={toggleAddVictimCard}
          assignedLawyer={get(
            props.claimRecap,
            'claim.assignment[0].assignedLawyer',
          )}
          setIsAssignmentDialogOpen={handleOpenAssignment}
          setOpenIsSuspiciosClaimDialog={setIsSuspiciosClaimDialog}
          handleToggleImagineDocDrawer={handleToggleDrawer}
          resetSagisInfoClaim={props.resetSagisInfoClaim}
          claimHasCivilPartyJudiciaryProcess={{}}
          handleToggleTrackingDrawer={handleToggleTrackingDrawer}
          requestSetStatusClaimSagis={props.requestSetStatusClaimSagis}
          isConsultation={false}
          listings={props.listings}
          handleResetStore={handleResetStore}
        />
      </StyledTopDiv>
      {featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) && (
        <TrackingActionDrawer
          isDrawerOpen={openTrackingDrawer}
          setIsDrawerOpen={handleToggleTrackingDrawer}
          userActions={props.userActions}
          listings={props.listings}
          claimHistorySagis={props.claimHistorySagis}
          claimNumber={claimNumber}
          claimId={claimId}
          requestGetClaimHistoryActions={props.requestGetClaimHistoryActions}
          requestGetClaimHistorySagis={props.requestGetClaimHistorySagis}
          loaders={props.loaders}
        />
      )}
      {featureService.hasFeature(FEATURES.FEE_NOTE) && (
        <DialogFeeNote
          allFeeNote={props.allFeeNote}
          requestAllFeeNotes={props.requestAllFeeNotes}
          feeNotes={filterFeeNotes(
            props.feeNotes,
            true,
            props.decisionJudgementIds,
            false,
          )}
          feeNotesCount={props.feeNotesCount}
          requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
          requestCreateFeeNote={props.requestCreateFeeNote}
          requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
          keyclokToken={props.keyclokToken}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          makeDecisionFeeNote={props.makeDecisionFeeNote}
          open={isDialogOpen}
          handleClose={handleClose}
          showButtonAdd={false}
          title={translate(messages.FeeNoteTitle, props)}
          claimNumber={get(props.claimRecap, 'claim.claimNumber')}
          listings={props.listings}
          page={0}
          setPage={() => {}}
          linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
          isExpert={true}
          requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
          loaders={props.loaders}
          requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
          requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
          requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
          contractorFeesSagis={get(props.sagisClaim, 'contractorFees')}
          isConsultation={false}
          requestUpdateFirmReferenceManager={
            props.requestUpdateFirmReferenceManager
          }
        />
      )}

      {isSuspiciosClaimDialog &&
        featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
          <SuspiciosClaimDialog
            open={isSuspiciosClaimDialog}
            claimId={claimId}
            onClose={() => setIsSuspiciosClaimDialog(false)}
            validateDialog={(payload: any, successCallBack: Function) =>
              props.requestIsSuspiciosClaim(payload, successCallBack)
            }
          />
        )}

      {featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) && (
        <ImagineDocumentsDrawer
          isDrawerOpen={OpenDrawerImagineDocuments}
          setIsDrawerOpen={setOpenDraweImagineDocuments}
          listings={props.listings}
          expandRow={expandRow}
          setExpandRow={setExpandRow}
          claimSagisInfo={resolveSagisClaim(props.policyInfo)}
          managerNotifcationsInboxes={props.managerNotifcationsInboxes}
          claimId={claimId}
          requestMakeDecisionsDocumentImaging={
            props.requestMakeDecisionsDocumentImaging
          }
          requestGetNotificationsInboxes={props.requestGetNotificationsInboxes}
          isConsultation={false}
          shouldDisplayUploadDocument={false}
          imagineNotification={{}}
          requestUploadDocumentManager={props.requestUploadDocumentManager}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      {featureService.hasFeature(FEATURES.DISCLAIMER_WARRANTY) && (
        <DialogDisclaimerWarranty
          open={isWarrantyDialogOpen}
          confirmTitle={translate(messages.validateWarrantyReason, props)}
          cancelTitle={translate(messages.cancelWarrantyReason, props)}
          handleClose={handleCloseWarrantyDialog}
          handleValidate={handleValidateWarrantyDialog}
          title={translate(messages.ExlusionOfWarranty, props)}
          listings={props.listings}
        />
      )}
      <SahamTabsGlobal>
        <GlobalLegalProceedingTabs
          currentTabIndex={currentTabIndex}
          labels={labels}
          setCurrentInstanceTab={props.setCurrentInstanceTab}
        >
          <ClaimRecap
            listings={props.listings}
            storedClaimToPreopen={props.storedClaimToPreopen}
            requestClaimRecap={props.requestClaimRecap}
            claimRecap={props.claimRecap}
            policyInfo={props.policyInfo}
            requestSearchClaims={props.requestSearchClaims}
            resetSearchClaimsStore={props.resetSearchClaimsStore}
            claimId={claimId}
            shouldDisplayBreadCrumbs={false}
            className="recap-bloc"
            shouldNotGetClaim
            stakeholders={stakeholders}
            requestUpdateVictimInfo={props.requestUpdateVictimInfo}
            requestUpdateBeneficiaryInfo={props.requestUpdateBeneficiaryInfo}
            requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
            setClaimRecap={props.setClaimRecap}
            requestCreateVehicle={props.requestAddVehicles}
            requestCreateVictim={props.requestAddVictims}
            isCourtManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMANAGER,
            )}
            requestUpdateClaim={props.requestUpdateClaim}
            resetUploadedDocument={props.resetUploadDocumentStore}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId}
            documentId={props.documentId}
            requestSagisClaimInfo={props.requestSagisClaimInfo}
            sagisInfo={props.sagisClaim}
            keycloakToken={props.keyclokToken}
            requestAddEligibilityTransaction={
              props.requestAddEligibilityTransaction
            }
            requestAddTransaction={props.requestAddTransaction}
            requestUpdateEligibilityTransaction={
              props.requestUpdateEligibilityTransaction
            }
            requestGetReportsPolicy={props.requestGetReportsPolicy}
            transactionInboxeAreaId={props.transactionInboxeAreaId}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
          <JudiciaryProcessTabs
            currentTabIndex={
              props.currentJudiciaryProccessId
                ? _.orderBy(
                    props.civilProceeding,
                    ['procedureNatureId'],
                    ['desc'],
                  )
                    .map((el: { id: number }) => el.id)
                    .indexOf(
                      Number(props.currentJudiciaryProccessId as any) as any,
                    )
                : 0
            }
            labels={labes}
            handleClickVerticalTabs={handleClickVerticalTabs}
          >
            {labes.map((label, index) => {
              return (
                <ManagerLegalProceedingsPage
                  currentJudiciaryProcess={
                    currentJudiciaryProcess
                      ? currentJudiciaryProcess
                      : props.currentJudiciaryProccessId
                  }
                  listings={props.listings}
                  onPressFeeNote={handleOpen}
                  onPressAssignment={() => {}}
                  storedClaimToPreopen={props.storedClaimToPreopen}
                  requestClaimRecap={props.requestClaimRecap}
                  getLegalProceedingsSteps={props.getLegalProceedingsSteps}
                  claimRecap={props.claimRecap}
                  currentSteps={props.currentSteps}
                  policyInfo={props.policyInfo}
                  requestSearchClaims={props.requestSearchClaims}
                  resetSearchClaimsStore={props.resetSearchClaimsStore}
                  match={props.match}
                  requestGetJudgementAdd={props.requestGetJudgementAdd}
                  judgementAdd={props.judgementAdd}
                  requestGetJudgementAddAppeal={
                    props.requestGetJudgementAddAppeal
                  }
                  judgementAddAppeal={props.judgementAddAppeal}
                  requestMakeJudgementAddDecision={
                    props.requestMakeJudgementAddDecision
                  }
                  requestGetExpertiseRaport={props.requestGetExpertiseRaport}
                  expertiseReport={props.expertiseReport}
                  requestValidateExpertReport={
                    props.requestValidateExpertReport
                  }
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  requestValidateJudgementOnMerits={
                    props.requestValidateJudgementOnMerits
                  }
                  requestGetJudgementOnMerits={
                    props.requestGetJudgementOnMerits
                  }
                  requestGetJudgementOnMeritsAppeal={
                    props.requestGetJudgementOnMeritsAppeal
                  }
                  judgementOnMeritsAppeal={props.judgementOnMeritsAppeal}
                  expertiseRaportAppeal={props.expertiseRaportAppeal}
                  requestGetExpertiseReportAppeal={
                    props.requestGetExpertiseReportAppeal
                  }
                  judgementOnMerits={props.judgementOnMerits}
                  documentId={props.documentId}
                  setDocumentId={props.setDocumentId}
                  judgementAppeal={props.judgementAppeal}
                  requestGetJudgementAppeal={props.requestGetJudgementAppeal}
                  requestValidateJudgementAppeal={
                    props.requestValidateJudgementAppeal
                  }
                  requestGetDahirAmount={props.requestGetDahirAmount}
                  dahirAmount={props.dahirAmount}
                  feeNotes={props.feeNotes}
                  feeNotesCount={props.feeNotesCount}
                  resetUploadDocumentStore={props.resetUploadDocumentStore}
                  requestManagerFeeNotes={props.requestManagerFeeNotes}
                  requestFeeNotesByClaimNumb={props.requestFeeNotesByClaimNumb}
                  requestCreateFeeNote={props.requestCreateFeeNote}
                  keyclokToken={props.keyclokToken}
                  makeDecisionFeeNote={props.makeDecisionFeeNote}
                  currentTabInstance={props.currentTabInstance}
                  setCurrentInstanceTab={props.setCurrentInstanceTab}
                  requestAllFeeNotes={props.requestAllFeeNotes}
                  allFeeNote={props.allFeeNote}
                  requestCorporealLawyers={props.requestCorporealLawyers}
                  corporealLawyers={props.corporealLawyers}
                  requestCreateCivilProceeding={
                    props.requestCreateCivilProceeding
                  }
                  requestGetCivilProceeding={props.requestGetCivilProceeding}
                  judiciaryProcessId={
                    idCivilProceeding
                      ? idCivilProceeding
                      : props.currentJudiciaryProccessId
                  }
                  civilProceeding={props.civilProceeding}
                  requestCreateJudgementOnMerits={
                    props.requestCreateJudgementOnMerits
                  }
                  requestUpdatedCivilProceeding={
                    props.requestUpdatedCivilProceeding
                  }
                  requestSagisClaimInfo={props.requestSagisClaimInfo}
                  sagisClaim={props.sagisClaim}
                  requestGetDahirAmountCorpo={props.requestGetDahirAmountCorpo}
                  dahirAmountsCorpo={props.dahirAmountsCorpo}
                  requestCreateJudgementOnMeritsContestation={
                    props.requestCreateJudgementOnMeritsContestation
                  }
                  requestValidatedCivilProceeding={
                    props.requestValidatedCivilProceeding
                  }
                  requestMakeJudgementAddDocumentDecision={
                    props.requestMakeJudgementAddDocumentDecision
                  }
                  updateContestation={props.updateContestation}
                  requestUploadContestationDocument={
                    props.requestUploadContestationDocument
                  }
                  requestUpdateVictimInfo={props.requestUpdateVictimInfo}
                  requestUpdateBeneficiaryInfo={
                    props.requestUpdateBeneficiaryInfo
                  }
                  requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
                  setClaimRecap={props.setClaimRecap}
                  requestAddVictims={props.requestAddVictims}
                  requestGetAppealOnMeritsMultiple={
                    props.requestGetAppealOnMeritsMultiple
                  }
                  requestGetJudgementOnMeritsMultiple={
                    props.requestGetJudgementOnMeritsMultiple
                  }
                  appealOnMeritsMultiple={props.appealOnMeritsMultiple}
                  judgementOnMeritsMultiple={props.judgementOnMeritsMultiple}
                  judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
                  requestGetJudgementOnMeritsByVictims={
                    props.requestGetJudgementOnMeritsByVictims
                  }
                  judgementOnMeritsByVehicles={
                    props.judgementOnMeritsByVehicles
                  }
                  requestGetJudgementOnMeritsByVehicles={
                    props.requestGetJudgementOnMeritsByVehicles
                  }
                  expertExpertise={props.expertExpertise}
                  requestMakeDecisionMissionExpertise={
                    props.requestMakeDecisionMissionExpertise
                  }
                  loaders={props.loaders}
                  requestCreateJudgementAdd={props.requestCreateJudgementAdd}
                  requestCreateMultipleJudgementAdd={
                    props.requestCreateMultipleJudgementAdd
                  }
                  requestCreateExpertiseRaport={
                    props.requestCreateExpertiseRaport
                  }
                  currentIndexTabManager={props.currentIndexTabManager}
                  currentInstanceTabIndexManager={
                    props.currentInstanceTabIndexManager
                  }
                  currentJudiciaryProccessId={props.currentJudiciaryProccessId}
                  requestAddSupportDocument={props.requestAddSupportDocument}
                  requestCivilPartySupportDocument={
                    props.requestCivilPartySupportDocument
                  }
                  requestAddExpertiseSupportDocument={
                    props.requestAddExpertiseSupportDocument
                  }
                  requestAddJudgementOnMeritsSupportDocument={
                    props.requestAddJudgementOnMeritsSupportDocument
                  }
                  currentGlobalTabManagerIndex={
                    props.currentGlobalTabManagerIndex
                  }
                  setIsButtonRedirect={setIsButtonRedirect}
                  isButtonRedirect={isButtonRedirect}
                  setOpenFeeNoteDialog={handleOpenFeeNoteDialog}
                  requestGetReportsPolicy={props.requestGetReportsPolicy}
                  requestGetClaimCivilParty={() => {}}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                  requestGetJudgements={props.requestGetJudgements}
                />
              );
            })}
          </JudiciaryProcessTabs>
          {get(
            renderTabsTitle(props)['PROVISION_AND_REGULATION'],
            'feature',
            false,
          ) && (
            <main>
              <LegalProceedingTabs
                labels={PROVISION_TAB_LABELS}
                currentTabIndex={0}
              >
                <ProvisionContainer
                  claimNumber={claimNumber}
                  listings={props.listings}
                  requestSagisClaimInfo={props.requestSagisClaimInfo}
                  sagisClaim={props.sagisClaim}
                  setIsDetail={() => {}}
                  requestValidateProvisionIntervenant={
                    props.requestValidateProvisionIntervenant
                  }
                  requestCreateStakeHolder={props.requestCreateStakeHolder}
                  claimId={claimId}
                  isConsultation={false}
                  lossDate={get(props.claimRecap, 'claim.lossDate')}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadDocumentStore={props.resetUploadDocumentStore}
                  uploadDocument={props.uploadDocument}
                  requestCreateFeeNoteManager={
                    props.requestCreateFeeNoteManager
                  }
                />
                <LegalProceedingTabs
                  labels={REGULATION_TAB_LABELS_CONSULTATION}
                  currentTabIndex={currentRegulationTab}
                  setCurrentInstanceTab={setCurrentRegulationTab}
                >
                  <div>
                    <RegulationRecapContainer
                      sagisClaim={props.sagisClaim}
                      listings={props.listings}
                      regulations={props.regulations}
                      isConsultation={true}
                      claimId={claimId}
                    />
                    <></>
                  </div>
                </LegalProceedingTabs>
              </LegalProceedingTabs>
            </main>
          )}
          {get(
            renderTabsTitle(props)['EXPERT_INTEGRATION'],
            'feature',
            false,
          ) && (
            <ExpertiseExpert
              match={props.match}
              requestMakeDecisionMissionExpertise={
                props.requestMakeDecisionMissionExpertise
              }
              requestMakeDecisionMissionNoticeDeficiency={
                props.requestMakeDecisionMissionNoticeDeficiency
              }
              isLawyer={true}
              requestFeeNotesByClaimNumb={props.requestFeeNotesByClaimNumb}
              claimNumber={claimNumber}
              onPressFeeNote={handleOpenExpertiseFeeNote}
              currentTabManagerExpertise={props.currentTabManagerExpertise}
              riskKey={riskKey}
              setOpenFeeNoteDialog={handleOpenFeeNoteDialog}
              claimRecap={props.claimRecap}
              resetSearchClaimsStore={props.resetSearchClaimsStore}
              resetStoreClaim={props.resetStoreClaim}
              resetSagisInfoClaim={props.resetSagisInfoClaim}
              resetLegalProceeding={props.resetLegalProceeding}
              policyInfo={props.policyInfo}
              currentIndexTabManager={props.currentIndexTabManager}
              currentInstanceTabIndexManager={
                props.currentInstanceTabIndexManager
              }
              currentTabInstance={props.currentTabInstance}
              requestSearchClaims={props.requestSearchClaims}
              listings={props.listings}
              requestSetPriorityClaimProvision={
                props.requestSetPriorityClaimProvision
              }
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              requestGetExpertiseVictim={props.requestGetExpertiseVictim}
            />
          )}
          {get(renderTabsTitle(props)['TRANSACTION'], 'feature', false) && (
            <Transaction
              match={props.match}
              claimNumber={claimNumber}
              claimRecap={props.claimRecap}
              resetSearchClaimsStore={props.resetSearchClaimsStore}
              resetStoreClaim={props.resetStoreClaim}
              resetSagisInfoClaim={props.resetSagisInfoClaim}
              resetLegalProceeding={props.resetLegalProceeding}
              policyInfo={props.policyInfo}
              requestSearchClaims={props.requestSearchClaims}
              requestGetTransaction={props.requestGetTransaction}
              requestAddTransaction={props.requestAddTransaction}
              uploadedDocument={props.uploadedDocument}
              resetUploadedDocument={props.resetUploadDocumentStore}
              uploadDocument={props.uploadDocument}
              requestUpdateTransaction={props.requestUpdateTransaction}
              requestAddContactTransaction={props.requestAddContactTransaction}
              requestGetContactTransaction={props.requestGetContactTransaction}
              resetStoreTransaction={props.resetStoreTransaction}
              requestUpdateContactTransaction={
                props.requestUpdateContactTransaction
              }
              corporealExperts={corporealExperts}
              requestGetExpertUsers={props.requestGetExpertUsers}
              requestAssignedExpert={props.requestAssignedExpert}
              riskKey={riskKey}
              requestGetMissionTransaction={props.requestGetMissionTransaction}
              requestMakeDecisionMissionExpertise={
                props.requestMakeDecisionMissionExpertise
              }
              requestGetMissionVictimExpertise={
                props.requestGetMissionVictimExpertise
              }
              requestUpdateMissionTransaction={
                props.requestUpdateMissionTransaction
              }
              requestGetFeeNotesTransaction={
                props.requestGetFeeNotesTransaction
              }
              onPressFeeNote={handleOpen}
              isConsultation={false}
              expertJudiciaryExpertise={props.expertExpertise}
              requestImportMissionExpertise={
                props.requestImportMissionExpertise
              }
              requestGetJudiciaryExpertReport={
                props.requestGetJudiciaryExpertReport
              }
              sagisInfo={props.sagisClaim}
              requestMakeDecisionVictimInfo={
                props.requestMakeDecisionVictimInfo
              }
              currentVerticalTabs={props.currentVerticalTabs}
              storedTransactionId={props.storedTransactionId}
              requestLockClaim={props.requestLockClaim}
              setLockedClaim={props.setLockedClaim}
              requestSetPriorityClaimProvision={
                props.requestSetPriorityClaimProvision
              }
              requestResetHistoryStore={props.requestResetHistoryStore}
              currentIndexTabManager={props.requestResetHistoryStore}
              currentInstanceTabIndexManager={
                props.currentInstanceTabIndexManager
              }
              currentGlobalTabManagerIndex={props.currentGlobalTabManagerIndex}
              currentJudiciaryProccessId={props.currentJudiciaryProccessId}
              requestRejectTransaction={props.requestRejectTransaction}
              setCurrentIndexTabTransaction={
                props.setCurrentIndexTabTransaction
              }
              requestGetDahirAmount={props.requestGetDahirAmount}
              dahirAmount={props.dahirAmount}
              requestCreateCorporealRegulation={
                props.requestCreateCorporealRegulation
              }
              regulations={props.regulations}
              requestGetRegulations={props.requestGetRegulations}
              requestSagisClaimInfo={props.requestSagisClaimInfo}
              requestGetRegulation={props.requestGetRegulation}
              requestValidateRegulation={props.requestValidateRegulation}
              requestAddQuotationDocument={props.requestAddQuotationDocument}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          )}
        </GlobalLegalProceedingTabs>
      </SahamTabsGlobal>
    </Container>
  );
};

const mapDispatchToProps = {
  requestUpdateVictimInfo,
  requestClaimRecap,
  requestSearchClaims,
  getLegalProceedingsSteps,
  resetSearchClaimsStore,
  requestGetJudgementAdd,
  requestMakeJudgementAddDecision,
  requestGetExpertiseRaport,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestGetJudgementOnMerits,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  uploadDocument,
  resetUploadDocumentStore,
  requestGetJudgementAppeal,
  requestValidateJudgementAppeal,
  requestGetDahirAmount,
  setDocumentId,
  requestManagerFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  makeDecisionFeeNote,
  setCurrentInstanceTab,
  requestAllFeeNotes,
  requestCorporealLawyers,
  requestCreateCivilProceeding,
  requestGetCivilProceeding,
  requestGetJudgementAddAppeal,
  requestCreateJudgementOnMerits,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestSagisClaimInfo,
  requestGetDahirAmountCorpo,
  requestCreateJudgementOnMeritsContestation,
  requestMakeJudgementAddDocumentDecision,
  requestAssigment,
  requestAddVictims,
  updateContestation,
  requestUploadContestationDocument,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestAddVehicles,
  requestGetAppealOnMeritsMultiple,
  requestGetJudgementOnMeritsMultiple,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestGetExpertiseVictim,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestCreateCorpoEncryptedDocument,
  requestCreateCorporealRegulation,
  requestCreateMaterialRegulation,
  requestCreateAdditionalWarrentiesRegulation,
  requestUpdateFeeNoteAmount,
  requestMaterialEncryptedDocument,
  requestIsSuspiciosClaim,
  requestCreateJudgementAdd,
  requestGetAssignedLawyers,
  requestCreateMultipleJudgementAdd,
  requestCreateExpertiseRaport,
  requestUpdateClaim,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
  requestValidateProvisionIntervenant,
  requestLockClaim,
  requestUnlockClaim,
  setLockedClaim,
  requestGetRegulations,
  resetStoreClaim,
  resetSagisInfoClaim,
  resetLegalProceeding,
  requestCreateSummarySheetRegulation,
  uploadDocumentRegulation,
  requestMakeDecisionsDocumentImaging,
  requestGetNotificationsInboxes,
  requestAddInvoiceFeeNote,
  requestValidateProvision,
  requestUpdateInvoiceFeeNote,
  requestGetClaimHistoryActions,
  requestUpdateFeeNoteStatus,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestCreateStakeHolder,
  requestSetPriorityClaimProvision,
  requestGetInstructions,
  requestCreateInstruction,
  requestResetHistoryStore,
  requestCreateFeeNoteManager,
  requestCreateIncomeCertificate,
  requestUpdateIncomeCertificate,
  requestAddEligibilityTransaction,
  requestUpdateEligibilityTransaction,
  requestAddTransaction,
  requestGetTransaction,
  requestUpdateTransaction,
  requestAddContactTransaction,
  requestGetContactTransaction,
  resetStoreTransaction,
  requestUpdateContactTransaction,
  requestGetExpertUsers,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestUpdateMissionTransaction,
  requestGetFeeNotesTransaction,
  requestGetReportsPolicy,
  requestImportMissionExpertise,
  requestGetJudiciaryExpertReport,
  requestMakeDecisionVictimInfo,
  requestRejectTransaction,
  setCurrentIndexTabTransaction,
  requestGetRegulation,
  requestValidateRegulation,
  requestAddQuotationDocument,
  requestUploadDocumentManager,
  requestGetTransactionInboxeArea,
  requestGetDocByDocumentumId,
  requestGetJudgements,
  requestUpdateFirmReferenceManager,
  requestGetDecisionFlowVictims,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  uploadedDocument: makeSelectDocument(),
  judgementAdd: makeSelectJudgementAdd(),
  currentSteps: makeSelectLegalProceedingsSteps(),
  expertiseReport: makeSelectExpertiseRaport(),
  judgementAddAppeal: makeSelectJudgementAddAppeal(),
  expertiseRaportAppeal: makeSelectExpertiseRaportAppeal(),
  judgementOnMerits: makeSelectJudgementOnMerits(),
  judgementOnMeritsAppeal: makeSelectJudgementOnMeritsAppeal(),
  judgementAppeal: makeSelectJudgementAppeal(),
  dahirAmount: makeSelectDahirAmounts(),
  documentId: makeSelectDocumentId(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  keyclokToken: makeSelectKeycloakToken(),
  currentTabInstance: makeSelectCurrentInstanceTab(),
  allFeeNote: makeSelectAllFeeNotes(),
  corporealLawyers: makeSelectCorporealLawyers(),
  civilProceeding: makeSelectCivilProceeding(),
  sagisClaim: makeSelectSagisClaim(),
  dahirAmountsCorpo: makeSelectDahirAmountsCorpo(),
  linkToBeneficiaryCodes: makeSelectLinkToBeneficiaryCodes(),
  judgementOnMeritsMultiple: makeSelectJudgementOnMeritsMultiple(),
  appealOnMeritsMultiple: makeSelectAppealOnMeritsMultiple(),
  judgementOnMeritsByVictims: makeSelectJudgementOnMeritsByVictims(),
  judgementOnMeritsByVehicles: makeSelectJudgementOnMeritsByVehicles(),
  corporealEncryptedDocuments: makeSelectEncryptedDocuments(),
  materialEncryptedDocuments: makeSelectMaterialEncryptedDocuments(),
  expertExpertise: makeSelectVictimExpertise(),
  loaders: selectedLoader,
  assignedLawyers: makeSelectAssignedLawyers(),
  currentIndexTabManager: makeSelectCurrentTabManager(),
  currentGlobalTabManagerIndex: makeSelectGlobalCurrentTabManager(),
  currentJudiciaryProccessId: makeSelectCurrentTabJudiciaryProcessManager(),
  regulations: makeRegulations(),
  createdRegulations: makeCreatedRegulations(),
  managerNotifcationsInboxes: makeSelectNotificationsInboxes(),
  currentTabManagerExpertise: makeSelectCurrentTabIndexExpertise(),
  decisionJudgementIds: makeSelectDecisionJudgmentIds(),
  claimHistoryActions: makeSelectClaimHistoryActions(),
  userActions: makeSelectClaimHistoryActions(),
  claimHistorySagis: makeSelectClaimHistorySagis(),
  instructions: makeInstructions(),
  currentVerticalTabs: makeSelectCurrentTabIndexTransaction(),
  storedTransactionId: makeSelectTransactionId(),
  transactionInboxeAreaId: makeSelectTransactionInboxeAreaId(),
  victimDecisionFlow: makeSelectDecisionFlowVictim(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TransactionManagerTimeLinePage));
